type EnumLike = Record<string, number>;
type EnumKey<TEnum extends EnumLike> = Extract<keyof TEnum, string>;
type EnumValue<TEnum extends EnumLike> = TEnum[EnumKey<TEnum>];

export function buildEnumNameMap<
    TEnum extends EnumLike,
    TLabels extends Readonly<Record<EnumKey<TEnum>, string>>,
>(
    source: TEnum,
    sourceLabels: TLabels
): Readonly<Record<EnumValue<TEnum>, TLabels[EnumKey<TEnum>]>> {
    const names: Partial<Record<EnumValue<TEnum>, TLabels[EnumKey<TEnum>]>> =
        {};

    for (const key of Object.keys(source) as EnumKey<TEnum>[]) {
        names[source[key] as EnumValue<TEnum>] = sourceLabels[key];
    }

    return names as Readonly<Record<EnumValue<TEnum>, TLabels[EnumKey<TEnum>]>>;
}

export function getEnumValueByName<TValue extends number>(
    nameMap: Readonly<Record<TValue, string>>,
    name: string
): TValue | null {
    for (const [rawValue, currentName] of Object.entries(nameMap)) {
        if (currentName === name) {
            return Number(rawValue) as TValue;
        }
    }

    return null;
}

export function isEnumName<TValue extends number>(
    nameMap: Readonly<Record<TValue, string>>,
    name: string
): boolean {
    return Object.values(nameMap).includes(name);
}
